/**
 * Format angka ke format currency Indonesia
 * @param {number|string} value - Nilai yang akan diformat
 * @returns {string} - Nilai yang sudah diformat (contoh: 10.000.000,12)
 */
export function formatCurrency(value) {
  if (value === null || value === undefined || value === '') {
    return '0';
  }

  const stringValue = value.toString();
  const parts = stringValue.split('.');
  
  // Format bagian integer dengan pemisah ribuan
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  
  // Gabungkan dengan bagian desimal jika ada
  const decimalPart = parts[1] ? `,${parts[1]}` : '';
  
  return integerPart + decimalPart;
}

/**
 * Format angka ke format currency Indonesia tanpa desimal
 * @param {number|string} value - Nilai yang akan diformat
 * @returns {string} - Nilai yang sudah diformat (contoh: 10.000.000)
 */
export function formatCurrencyNoDecimal(value) {
  if (value === null || value === undefined || value === '') {
    return '0';
  }

  const stringValue = value.toString();
  const parts = stringValue.split('.');
  
  // Hanya ambil bagian integer
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  
  return integerPart;
}
